import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import DatePicker from 'react-datepicker';

import config from './../config';
import nyyrdiHelper from './../nyyrdiHelper';

class SendForm extends Component {
	constructor(props) {
		super(props);

		this.languages = [
			['en', 'Enska'],
			['da', 'Danska'],
			['no', 'Norska'],
			['nb', 'Norska (Bokmål)'],
			['sv', 'Sænska'],
			['de', 'Þýska'],
			['aa', 'Afar'],
			['ab', 'Abkhazian'],
			['ae', 'Avestan'],
			['af', 'Afrikaans'],
			['ak', 'Akan'],
			['am', 'Amharic'],
			['an', 'Aragonese'],
			['ar', 'Arabic'],
			['as', 'Assamese'],
			['av', 'Avaric'],
			['ay', 'Aymara'],
			['az', 'Azerbaijani'],
			['ba', 'Bashkir'],
			['be', 'Belarusian'],
			['bg', 'Bulgarian'],
			['bh', 'Bihari languages'],
			['bi', 'Bislama'],
			['bm', 'Bambara'],
			['bn', 'Bengali'],
			['bo', 'Tibetan'],
			['br', 'Breton'],
			['bs', 'Bosnian'],
			['ca', 'Catalan; Valencian'],
			['ce', 'Chechen'],
			['ch', 'Chamorro'],
			['co', 'Corsican'],
			['cr', 'Cree'],
			['cs', 'Czech'],
			['cu', 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic'],
			['cv', 'Chuvash'],
			['cy', 'Welsh'],
			['cy', 'Welsh'],
			['dv', 'Divehi; Dhivehi; Maldivian'],
			['dz', 'Dzongkha'],
			['ee', 'Ewe'],
			['el', 'Greek, Modern (1453-)'],
			['el', 'Greek, Modern (1453-)'],
			['eo', 'Esperanto'],
			['es', 'Spanish; Castilian'],
			['et', 'Estonian'],
			['eu', 'Basque'],
			['eu', 'Basque'],
			['fa', 'Persian'],
			['ff', 'Fulah'],
			['fi', 'Finnish'],
			['fj', 'Fijian'],
			['fo', 'Faroese'],
			['fr', 'French'],
			['fr', 'French'],
			['fy', 'Western Frisian'],
			['ga', 'Irish'],
			['gd', 'Gaelic; Scottish Gaelic'],
			['gl', 'Galician'],
			['gn', 'Guarani'],
			['gu', 'Gujarati'],
			['gv', 'Manx'],
			['ha', 'Hausa'],
			['he', 'Hebrew'],
			['hi', 'Hindi'],
			['ho', 'Hiri Motu'],
			['hr', 'Croatian'],
			['ht', 'Haitian; Haitian Creole'],
			['hu', 'Hungarian'],
			['hy', 'Armenian'],
			['hy', 'Armenian'],
			['hz', 'Herero'],
			['ia', 'Interlingua (International Auxiliary Language Association)'],
			['id', 'Indonesian'],
			['ie', 'Interlingue; Occidental'],
			['ig', 'Igbo'],
			['ii', 'Sichuan Yi; Nuosu'],
			['ik', 'Inupiaq'],
			['io', 'Ido'],
			['is', 'Icelandic'],
			['it', 'Italian'],
			['iu', 'Inuktitut'],
			['ja', 'Japanese'],
			['jv', 'Javanese'],
			['ka', 'Georgian'],
			['ka', 'Georgian'],
			['kg', 'Kongo'],
			['ki', 'Kikuyu; Gikuyu'],
			['kj', 'Kuanyama; Kwanyama'],
			['kk', 'Kazakh'],
			['kl', 'Kalaallisut; Greenlandic'],
			['km', 'Central Khmer'],
			['kn', 'Kannada'],
			['ko', 'Korean'],
			['kr', 'Kanuri'],
			['ks', 'Kashmiri'],
			['ku', 'Kurdish'],
			['kv', 'Komi'],
			['kw', 'Cornish'],
			['ky', 'Kirghiz; Kyrgyz'],
			['la', 'Latin'],
			['lb', 'Luxembourgish; Letzeburgesch'],
			['lg', 'Ganda'],
			['li', 'Limburgan; Limburger; Limburgish'],
			['ln', 'Lingala'],
			['lo', 'Lao'],
			['lt', 'Lithuanian'],
			['lu', 'Luba-Katanga'],
			['lv', 'Latvian'],
			['mg', 'Malagasy'],
			['mh', 'Marshallese'],
			['mi', 'Maori'],
			['mi', 'Maori'],
			['mk', 'Macedonian'],
			['ml', 'Malayalam'],
			['mn', 'Mongolian'],
			['mr', 'Marathi'],
			['ms', 'Malay'],
			['ms', 'Malay'],
			['mt', 'Maltese'],
			['my', 'Burmese'],
			['na', 'Nauru'],
			['nd', 'Ndebele, North; North Ndebele'],
			['ne', 'Nepali'],
			['ng', 'Ndonga'],
			['nl', 'Dutch; Flemish'],
			['nr', 'Ndebele, South; South Ndebele'],
			['nv', 'Navajo; Navaho'],
			['ny', 'Chichewa; Chewa; Nyanja'],
			['oc', 'Occitan (post 1500)'],
			['oj', 'Ojibwa'],
			['om', 'Oromo'],
			['or', 'Oriya'],
			['os', 'Ossetian; Ossetic'],
			['pa', 'Panjabi; Punjabi'],
			['pi', 'Pali'],
			['pl', 'Polish'],
			['ps', 'Pushto; Pashto'],
			['pt', 'Portuguese'],
			['qu', 'Quechua'],
			['rm', 'Romansh'],
			['rn', 'Rundi'],
			['ro', 'Romanian; Moldavian; Moldovan'],
			['ru', 'Russian'],
			['rw', 'Kinyarwanda'],
			['sa', 'Sanskrit'],
			['sc', 'Sardinian'],
			['sd', 'Sindhi'],
			['se', 'Northern Sami'],
			['sg', 'Sango'],
			['si', 'Sinhala; Sinhalese'],
			['sk', 'Slovak'],
			['sl', 'Slovenian'],
			['sm', 'Samoan'],
			['sn', 'Shona'],
			['so', 'Somali'],
			['sq', 'Albanian'],
			['sq', 'Albanian'],
			['sr', 'Serbian'],
			['ss', 'Swati'],
			['st', 'Sotho, Southern'],
			['su', 'Sundanese'],
			['sw', 'Swahili'],
			['ta', 'Tamil'],
			['te', 'Telugu'],
			['tg', 'Tajik'],
			['th', 'Thai'],
			['ti', 'Tigrinya'],
			['tk', 'Turkmen'],
			['tl', 'Tagalog'],
			['tn', 'Tswana'],
			['to', 'Tonga (Tonga Islands)'],
			['tr', 'Turkish'],
			['ts', 'Tsonga'],
			['tt', 'Tatar'],
			['tw', 'Twi'],
			['ty', 'Tahitian'],
			['ug', 'Uighur; Uyghur'],
			['uk', 'Ukrainian'],
			['ur', 'Urdu'],
			['uz', 'Uzbek'],
			['ve', 'Venda'],
			['vi', 'Vietnamese'],
			['vo', 'Volapük'],
			['wa', 'Walloon'],
			['wo', 'Wolof'],
			['xh', 'Xhosa'],
			['yi', 'Yiddish'],
			['yo', 'Yoruba'],
			['za', 'Zhuang; Chuang'],
			['zh', 'Chinese'],
			['zh', 'Chinese'],
			['zu', 'Zulu'],
		];

		this.formInputChangeHandler = this.formInputChangeHandler.bind(this);
		this.sendButtonClickHandler = this.sendButtonClickHandler.bind(this);
		this.eventBusSendFormSuccessHandler = this.eventBusSendFormSuccessHandler.bind(this);

		this.state = {
			formData: {
				/*
				ord: '',
				ordflokkur: '',
				kyn: '',
				merking: '',
				uppruni_sendandi: '',
				dagsetning: '',
				uppruni_erl_lang: '',
				uppruni_erl_ord: '',
				heimild_daemi: '',
				heimild_source: '',
				sendandi_nafn: '',
				sendandi_faedingarar: '',
				sendandi_netfang: '',
				sendandi_heimilisfang: '',
				sendandi_postnumer: '',
				sendandi_stadur: '',
				sendandi_hideinfo: ''
				*/
			},
			sendComplete: false,
			validationError: false,
			initialized: false
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		window.EventBus.addEventListener('success.sendcomment', this.eventBusSendFormSuccessHandler);

		this.getUserInfo();

		setTimeout(function() {
			this.setState({
				initialized: true
			});
		}.bind(this), 500);
	}

	componentWillUnmount() {
		window.EventBus.removeEventListener('success.sendcomment', this.eventBusSendFormSuccessHandler);
	}

	validateForm() {
		const heimildSourceLength = 120;

		let validationError = [];

		if (this.state.formData.ord &&
			this.state.formData.merking &&
			this.state.formData.uppruni_sendandi &&
			this.state.formData.sendandi_nafn &&
			this.state.formData.sendandi_netfang &&
			nyyrdiHelper.validateEmail(this.state.formData.sendandi_netfang) &&
			(!this.state.formData.sendandi_postnumer || this.state.formData.sendandi_postnumer == '' || !isNaN(this.state.formData.sendandi_postnumer)) &&
			(!this.state.formData.sendandi_faedingarar || this.state.formData.sendandi_faedingarar == '' || !isNaN(this.state.formData.sendandi_faedingarar)) &&
			(!this.state.formData.dagsetning || this.state.formData.dagsetning == '' || (this.state.formData.dagsetning.match(/^([0-9]{1,2})-([0-9]{1,2})-([0-9]{4})$/))) &&
			(!this.state.formData.heimild_url || this.state.formData.heimild_url == '' || (this.state.formData.heimild_url.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]*$/))) &&
			(!this.state.formData.heimild_source || this.state.formData.heimild_source.length < heimildSourceLength)
		) {
			this.setState({
				validationError: []
			});

			console.log('validation success')

			return true;
		}
		else {
			if (!this.state.formData.ord || !this.state.formData.merking) {
				validationError.push('Þú verður að skrifa sjálft nýyrðið og merkingu þess.');
			}

			if (!this.state.formData.uppruni_sendandi) {
				validationError.push('Þú verður að tilgreina hvaðan nýyrðið kemur.');
			}

			if (!nyyrdiHelper.validateEmail(this.state.formData.sendandi_netfang)) {
				validationError.push('Þú verður að skrifa gilt netfang.');
			}

			if (this.state.formData.sendandi_faedingarar && isNaN(this.state.formData.sendandi_faedingarar)) {
				validationError.push('Þú verður að skrifa gilt fæðingarár.');
			}

			if (this.state.formData.sendandi_postnumer && isNaN(this.state.formData.sendandi_postnumer)) {
				validationError.push('Þú verður að skrifa gilt póstnúmer.');
			}

			if (this.state.formData.dagsetning && !this.state.formData.dagsetning.match(/^([0-9]{1,2})-([0-9]{1,2})-([0-9]{4})$/)) {
				validationError.push('Þú verður að skrifa gilda dagsetningu.');
			}

			if (this.state.formData.heimild_url && !this.state.formData.heimild_url.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]*$/)) {
				validationError.push('Þú verður að skrifa gilda vefslóð.');
			}

			if (this.state.formData.heimild_source && this.state.formData.heimild_source.length > heimildSourceLength) {
				validationError.push('Heimild má ekki vera lengri en '+heimildSourceLength+' tákn.');
			}

			this.setState({
				validationError: validationError
			});

			console.log('validation fail')

			return false;
		}
	}

	saveUserInfo() {
		let userData = {
			sendandi_nafn: this.state.formData.sendandi_nafn,
			sendandi_netfang: this.state.formData.sendandi_netfang,
			sendandi_faedingarar: this.state.formData.sendandi_faedingarar,
			sendandi_heimilisfang: this.state.formData.sendandi_heimilisfang,
			sendandi_postnumer: this.state.formData.sendandi_postnumer,
			sendandi_stadur: this.state.formData.sendandi_stadur,
			sendandi_hideinfo: this.state.formData.sendandi_hideinfo
		};

		localStorage.setItem('nyyrdi_userdata', JSON.stringify(userData));
	}

	getUserInfo() {
		if (localStorage.getItem('nyyrdi_userdata')) {
			let userData = JSON.parse(localStorage.getItem('nyyrdi_userdata'));

			let formData = this.state.formData;

			Object.assign(formData, userData);

			this.setState({
				formData: formData
			});
		}
	}

	sendButtonClickHandler(event) {
		event.preventDefault();

		if (this.validateForm()) {
			this.saveUserInfo();

			this.sendFormData();
		}
	}

	prepareData(data) {
		let ret = {};

		for (let key in data) {
			if (data[key] != '') {
				ret[key] = data[key];
			}
		}

		if (ret.heimild_url && ret.heimild_url.toLowerCase().substr(0, 7) != 'http://' && ret.heimild_url.toLowerCase().substr(0, 8) != 'https://') {
			ret.heimild_url = 'http://'+ret.heimild_url;
		}

		return ret;
	}

	sendFormData() {
		window.EventBus.dispatch('data.send', {
			type: 'sendform',
			data: this.prepareData(this.state.formData)
		});
	}

	eventBusSendFormSuccessHandler() {
		this.props.history.push('/sendu/takk');
	}

	formInputChangeHandler(event) {
		let value = event._isAMomentObject ? event.format('D-MM-YYYY') : event.target.type && event.target.type == 'checkbox' ? event.target.checked : event.target.value;

		let formData = this.state.formData;

		formData[event._isAMomentObject ? 'dagsetning' : event.target.name] = value;

		this.setState({
			formData: formData
		});
	}

	fetchData() {
		// Sæki gögn til APA

		fetch(this.url+this.props.match.params.nyyrdi)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json
				})
			}.bind(this));
	}

	render() {
		return (
			<div className={'content-container manual-init'+(this.state.initialized ? ' initialized' : '')}>
				<h3><span>Sendu okkur nýyrði</span></h3>
				{
					this.props.takk &&
					<div>Takk fyrir. Nýyrðið verður skráð í nýyrðagrunn stofnunarinnar og yfirfarið af ritstjóra.</div>
				}
				{
					!this.props.takk &&
					<React.Fragment>
						<form className="send-form">
							<p>Þú getur hjálpað okkur með því að senda inn ný orð sem ekki standa í orðabókum. 
								Orðin eru send til málræktarsviðs Stofnunar Árna Magnússonar í íslenskum fræðum þar sem þau verða skráð í gagnagrunn og mun úrval þeirra birtast hér á þessum vef.</p>

							<h4><span>Upplýsingar um nýyrðið</span></h4>

							<div className="row">
								<div className="col">
									<label>Hvert er nýyrðið</label>
									<input required 
											onChange={this.formInputChangeHandler} 
										name="ord" 
										value={this.state.formData.ord} 
										type="text" 
										className="form-control" />
								</div>
							</div>

							<div className="row">
								<div className="col">
									<label>Orðflokkur</label>
									<select onChange={this.formInputChangeHandler} 
										name="ordflokkur" 
										value={this.state.formData.ordflokkur} 
										className="form-control"
									>
										<option></option>
										<option value="">Veit ekki</option>
										<option value="n">Nafnorð</option>
										<option value="v">Sagnorð</option>
										<option value="adj">Lýsingarorð</option>
										<option value="adv">Atviksorð</option>
										<option value="ordasamband">Orðasamband</option>
										<option value="?">Annað</option>
									</select>
								</div>
								<div className="col">
									<label>Kyn</label>
									<select onChange={this.formInputChangeHandler} 
										name="kyn" 
										value={this.state.formData.kyn} 
										className="form-control"
									>
										<option></option>
										<option value="kk">Karlkyn</option>
										<option value="kvk">Kvenkyn</option>
										<option value="hk">Hvorugkyn</option>
									</select>
								</div>
							</div>

							<div className="row">
								<div className="col">
									<label>{'Hvað merkir nýyrðið?'}</label>
									<textarea required 
										onChange={this.formInputChangeHandler} 
										name="merking" 
										className="form-control"
										value={this.state.formData.merking}
									></textarea>
								</div>
							</div>

							<h4><span>{'Uppruni '+(this.state.formData.ord && this.state.formData.ord.length > 3 ? 'orðsins „'+this.state.formData.ord+'“' : 'nýyrðis')+'?'}</span></h4>

							<div className="row">
								<div className="col">
									<label>{'Hvaðan kemur nýyrðið?'}</label>
									<select required 
										onChange={this.formInputChangeHandler} 
										name="uppruni_sendandi" 
										value={this.state.formData.uppruni_sendandi} 
										className="form-control"
									>
										<option></option>
										<option value="uppr_prent">Ég sá orðið á prenti</option>
										<option value="uppr_tal">Ég heyrði orðið</option>
										<option value="uppr_heimagert">Ég bjó orðið til</option>
										<option value="uppr_thyding">Þýðing úr öðru tungumáli</option>
										<option value="uppr_annad">Annað</option>
									</select>
								</div>

								<div className="col">
									<label>Upprunatungumál</label>
									<select onChange={this.formInputChangeHandler} 
										name="uppruni_erl_lang" 
										value={this.state.formData.uppruni_erl_lang} 
										className="form-control"
									>
										<option></option>
										{
											this.languages.map(function(lang, index) {
												return <option key={index} value={lang[0]}>{lang[1]}</option>
											})
										}
									</select>
									<small>Á aðeins við ef orðið kemur úr öðru máli.</small>
								</div>

								<div className="col">
									<label>Erlend samsvörun</label>
									<input onChange={this.formInputChangeHandler} 
										name="uppruni_erl_ord" 
										value={this.state.formData.uppruni_erl_ord} 
										type="text" 
										className="form-control" />
								</div>

							</div>

							<h4><span>Heimild og dæmi</span></h4>

							<p>Hér biðjum við þig um að nefna hvar og hvenær þú sást eða heyrðir nýyrðið <strong>fyrst</strong>. Ef um örugga heimild er að ræða, til dæmis í prentmiðli eða öðrum fjölmiðli biðjum við þig um að nefna nafn miðils, blaðsíðutal ef við á eða vefslóð ef hana er að finna.</p>

							<div className="row">
								<div className="col">
									<label>Skrifaðu setninguna þar sem þú last eða heyrðir nýyrðið fyrst</label>
									<textarea onChange={this.formInputChangeHandler} 
										name="heimild_daemi" 
										value={this.state.formData.heimild_daemi}
										className="form-control"/>
								</div>
							</div>

							<div className="row">

								<div className="col">
									<label>Skrifaðu eins nákvæmlega og þú getur hvar þú sást nýyrðið fyrst</label>
									<input onChange={this.formInputChangeHandler} 
										name="heimild_source" 
										value={this.state.formData.heimild_source}
										className="form-control"/>
									<small>Dæmi: Morgunblaðið, bls. 3, 22. október 2017.</small>
								</div>

							</div>

							<div className="row">

								<div className="col">
									<label>Hvenær sástu eða heyrðir þú nýyrðið fyrst?</label>
									{/*
									<input onChange={this.formInputChangeHandler} 
										type="date" 
										name="dagsetning" 
										value={this.state.formData.dagsetning} 
										className="form-control"/>
									*/}
									<DatePicker onChange={this.formInputChangeHandler} onChangeRaw={this.formInputChangeHandler}
										name="dagsetning" 
										dateFormat="DD-MM-YYYY"
										className="form-control"
										value={this.state.formData.dagsetning}
									/>
									<small>Dæmi: 16-11-2018.</small>
								</div>

								<div className="col">
									<label>Vefslóð heimildar (ef við á)</label>
									<input onChange={this.formInputChangeHandler} 
										name="heimild_url" 
										value={this.state.formData.heimild_url}
										className="form-control"/>
								</div>

							</div>


							<div className="row">
								<div className="col">
									<label>Athugasemd til ritstjóra</label>
									<textarea onChange={this.formInputChangeHandler} 
										name="athugasemd" 
										value={this.state.formData.athugasemd}
										className="form-control"/>
									<small>Hér getur þú skrifað athugasemd eða nánari skýringu sem þú villt koma á framfæri til ritstjóra. Þessi reitur verður ekki birtur á vefnum.</small>
								</div>
							</div>

							<h4><span>Upplýsingar um þig</span></h4>

							<div className="row">
								<div className="col">
									<label>Nafn</label>
									<input required 
										onChange={this.formInputChangeHandler} 
										name="sendandi_nafn" 
										value={this.state.formData.sendandi_nafn} 
										type="text" 
										className="form-control" />
									{
										this.state.formData.sendandi_hideinfo &&
										<small>Nafnið þitt verður ekki birt.</small>
									}
								</div>
								<div className="col">
									<label>Fæðingarár</label>
									<input onChange={this.formInputChangeHandler} 
										name="sendandi_faedingarar" 
										value={this.state.formData.sendandi_faedingarar} 
										type="text" 
										className="form-control" />
									<small>Fæðingarár verður ekki birt.</small>
								</div>
							</div>

							<div className="row">
								<div className="col">
									<label>Netfang</label>
									<input required 
										onChange={this.formInputChangeHandler} 
										name="sendandi_netfang" 
										value={this.state.formData.sendandi_netfang} 
										type="text" 
										className="form-control" />
									<small>Netfang verður ekki birt.</small>
								</div>
							</div>

							<div className="row">
								<div className="col">
									<label>Heimilisfang</label>
									<input onChange={this.formInputChangeHandler} 
										name="sendandi_heimilisfang" 
										value={this.state.formData.sendandi_heimilisfang} 
										type="text" 
										className="form-control" />
									<small>Heimilisfang verður ekki birt.</small>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Póstnúmer</label>
									<input onChange={this.formInputChangeHandler} 
										name="sendandi_postnumer" 
										value={this.state.formData.sendandi_postnumer} 
										type="text" 
										className="form-control" />
								</div>
								<div className="col-md-8">
									<label>Staður</label>
									<input onChange={this.formInputChangeHandler} 
										name="sendandi_stadur" 
										value={this.state.formData.sendandi_stadur} 
										type="text" 
										className="form-control" />
									<small>Póstnúmer og staður verður ekki birt.</small>
								</div>
							</div>

							<div className="row">
								<div className="col">
									<div className="form-check">
										<label className="form-check-label">
											<input onChange={this.formInputChangeHandler} 
												type="checkbox" 
												className="form-check-input" 
												id="sendandi_hideinfo" 
												checked={this.state.formData.sendandi_hideinfo}
												name="sendandi_hideinfo" /> Ég vil ekki að nafnið mitt verði sýnilegt á vefnum</label>
									</div>
								</div>
							</div>

							<div>
								<br />
								{
									this.state.validationError && this.state.validationError.length > 0 &&
									<p><strong dangerouslySetInnerHTML={{__html: this.state.validationError.join('<br/>')}}></strong></p>
								}
								<button className="btn btn-primary" onClick={this.sendButtonClickHandler}>Senda</button>
							</div>

						</form>
					</React.Fragment>
				}
			</div>
		);
	}
}

export default withRouter(SendForm);



// WEBPACK FOOTER //
// ./src/components/SendForm.js